export const AppToolbarFeatureToggleConfig = {};
